export const PAGE_PATH = '/auth/verification-email';
